import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

export const firebaseConfig = {
  apiKey: "AIzaSyB8rt_uu8OIn_--HlrntObKPDvNw6fBkmY",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? "wiley-phone.firebaseapp.com",
  projectId: "wiley-phone",
  storageBucket: "wiley-phone.firebasestorage.app",
  messagingSenderId: "303036321146",
  appId: "1:303036321146:web:d65702fbfb659312131ac3",
  measurementId: "G-41317WHGHN"
};

// Initialize Firebase
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export { app };
